import Error from '../model/Error';
import axios from 'axios';

export default class MembershipChangeRequestRepository {

    static getCountAndRequestsByClub(clubId, status, sort, direction, limit, offset, departmentId, changeType) {
        return Promise.all([
            this.countByClub(clubId, status, departmentId, changeType),
            this.findByClub(clubId, status, sort, direction, limit, offset, departmentId, changeType),
        ]);
    }

    static findByClub(clubId, status, sort, direction, limit, offset, departmentId, changeType) {
        let query = `?status=${status}`;
        if (sort) {
            query += `&sort=${sort}&direction=${direction}`;
        }
        if (limit !== null && typeof limit !== 'undefined') {
            query += `&limit=${limit}&offset=${offset}`;
        }
        query += this.filterQuery(departmentId, changeType);
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/membership-change-requests${query}`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static countByClub(clubId, status, departmentId, changeType) {
        const query = `?status=${status}` + this.filterQuery(departmentId, changeType);
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/membership-change-requests/count${query}`)
                .then(response => resolve(response.data.data.count))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static filterQuery(departmentId, changeType) {
        let query = '';
        if (departmentId) {
            query += `&department=${departmentId}`;
        }
        if (changeType) {
            query += `&changeType=${changeType}`;
        }
        return query;
    }

    static getDepartments(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/membership-change-requests/departments`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static process(requestId, date) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/membership-change-requests/${requestId}/process`, { date })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static processDeletion(requestId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/membership-change-requests/${requestId}/process`, { deleteMembership: true })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static reject(requestId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/membership-change-requests/${requestId}/reject`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
